
        var result = require("!!../../../../node_modules/css-loader/index.js!./btw.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/btw.component.css
// module id = 2381
// module chunks = 1